import { Component, OnInit } from '@angular/core';
import { User } from '../../models/user';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl } from '@angular/forms';
import { ValidationService } from '../../services/validation.service';
import { SharedService } from '../../services/shared.service';
import { LoaderService } from '../../services/Spinner.service';
import { PasswordValidation } from '../../users/password-validation';
@Component({
  selector: 'app-resetconfirm',
  templateUrl: './resetconfirm.component.html',
  providers : [SharedService]
})
export class AdminResetconfirmComponent implements OnInit {
   user = new User();
  key : string;
  resetForm: FormGroup;
  flag : boolean=true;
  constructor(private formBuilder: FormBuilder,private shareService :SharedService,private router : Router,private loaderService :LoaderService) { }

  ngOnInit() {
   let body = document.getElementsByTagName('body')[0];
   body.classList.remove("zizbackground");
         body.classList.remove("overflow");

    this.resetForm = this.formBuilder.group({
      newpassword: ['', Validators.compose([ValidationService.passwordValidator])],
      confirmpassword: ['', Validators.required]
     // newpassword: ['', Validators.compose([ValidationService.passwordValidator])],
    },
    {
      validator: PasswordValidation.MatchPassword // your validation method
    });
    
    let currentUrl = this.router.url;
    console.log(currentUrl);
    this.key=currentUrl.substr(currentUrl.lastIndexOf('/') + 1);
    console.log("key data"+this.key);
    this.shareService.CallDatawithToken('auth/verifyKey/'+this.key,null,"1").subscribe((result) => {
        console.log(result);
        if((result.data)) { 
          this.flag=true;
          } else {
            this.flag=false;
          }
   });
  }

  onSubmit() {
     this.loaderService.displayLoader(true);
     let resetData = {
       "password":this.resetForm.value.newpassword,
       "confirmPass":this.resetForm.value.confirmpassword,
       "passKey":this.key
      }
      var ur="?password="+resetData.password+"&confirmPass="+resetData.confirmPass+"&passKey="+resetData.passKey;
      console.log(resetData)
      console.log(resetData);
      this.shareService.callApiWithToken("auth/updatePassword"+ur,{},"1").subscribe((result) => {
        this.loaderService.displayLoader(false);
        if ((result.data)) {
            this.user.successMsg = true;
            setTimeout(function () {
            this.user.successMsg = false;
            this.router.navigate(['admin/login'])
        }.bind(this), 10000);
        } else {
         this.user.servererrormsg=true;
          setTimeout(function () {
            this.user.successMsg = false;
        }.bind(this), 10000);
        }
         this.loaderService.displayLoader(false);
        //  this.router.navigate(['/signup']);
         
   });
}

}



// WEBPACK FOOTER //
// ./src/app/admin/resetConfirm/resetconfirm.component.ts